@if (loading) {
    <ion-spinner @coreShowHideAnimation [attr.aria-label]="loadingLabel | translate" />
} @else {
    <div @coreShowHideAnimation>
        <ng-content />
    </div>
}
